import { createContext, useContext, useEffect } from 'react';
import { type HubConnection, HubConnectionState } from '@microsoft/signalr';

interface SignalConnection {
    connection?: HubConnection;
    connectionStatus: HubConnectionState;
}

// a type alias for microsoft's SignalR client callback
// e.g. https://github.com/dotnet/aspnetcore/blob/79ef5e329b1e31c3775a1977798253cc8f7da6cc/src/SignalR/clients/ts/signalr/src/HubConnection.ts#L541
export type HubCallback = (...args: string[]) => void;

export const SignalContext = createContext<SignalConnection>({
    connection: undefined,
    connectionStatus: HubConnectionState.Disconnected,
});

export function useHubMethod(methodName: string, callback: HubCallback) {
    const { connection, connectionStatus } = useContext(SignalContext);

    useEffect(() => {
        if (!connection || connectionStatus !== HubConnectionState.Connected) {
            return;
        }

        connection.on(methodName, callback);
        return () => connection.off(methodName, callback);
    }, [connection, connectionStatus, methodName, callback]);
}

export function useIsSignalRConnected() {
    const { connectionStatus } = useContext(SignalContext);

    return connectionStatus === HubConnectionState.Connected;
}
